import { render, staticRenderFns } from "./AppMenuListPage.vue?vue&type=template&id=78d70ff7&scoped=true&"
import script from "./AppMenuListPage.vue?vue&type=script&lang=ts&"
export * from "./AppMenuListPage.vue?vue&type=script&lang=ts&"
import style0 from "./AppMenuListPage.vue?vue&type=style&index=0&id=78d70ff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d70ff7",
  null
  
)

export default component.exports